export default function RefundPolicyPage() {
  return (
    <div className="bg-background min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-text-primary mb-8">Refund Policy</h1>
        <div className="prose prose-lg dark:prose-invert text-text-secondary max-w-none">
          <p>
            At Rohith's Academy, we strive to provide the best educational experience. Please read our refund policy carefully before making a purchase.
          </p>

          <h3>1. Refund Eligibility</h3>
          <p>
            We offer a 7-day refund policy for selected courses. If you are not satisfied with the course content, you may request a refund within 7 days of purchase, provided you have not completed more than 20% of the course.
          </p>

          <h3>2. Non-Refundable Items</h3>
          <p>The following are non-refundable:</p>
          <ul>
            <li>Test Series and Mock Exams.</li>
            <li>Digital downloads and study materials.</li>
            <li>Fees paid for live mentorship sessions once attended.</li>
          </ul>

          <h3>3. How to Request a Refund</h3>
          <p>
            To request a refund, please email us at support@rohithsacademy.com with your order details and the reason for the request.
          </p>

          <h3>4. Processing Time</h3>
          <p>
            Refunds will be processed within 5-7 business days of approval and credited back to the original payment method.
          </p>
        </div>
      </div>
    </div>
  );
}

